import { render, staticRenderFns } from "./M2hLayout.vue?vue&type=template&id=1a8c0cd1&"
import script from "./M2hLayout.vue?vue&type=script&lang=js&"
export * from "./M2hLayout.vue?vue&type=script&lang=js&"
import style0 from "./M2hLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports